<template>
    <div class="game-select"
         :class="{'active': isOpen}"
         v-click-outside="closeGameSelect">
        <div class="game-select__toggle" @click="toggleGameSelect">
            {{currentGameType||'Выбор игры'}}
        </div>
        <ul class="game-select__menu">
            <li class="game-select__menu-item" v-for="gameType in gameTypes">
                {{gameType.name}}
                <ul class="game-select__sub-menu" v-if="gameType.items">
                    <li class="game-select__sub-menu-item" v-for="item in gameType.items"
                        @click="selectGameType"
                        :data-title="`${gameType.name}: ${item}`">
                        {{item}}
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        selectedGame: {
            required: false,
            type: String
        }
    },
    data() {
        return {
            isOpen: false,
            currentGameType: null,
            gameTypes: [
                {
                    name: 'Крокодил',
                    items: [
                        'Взросло-отвязный',
                        'Кино-книжный'
                    ]
                },
                {
                    name: 'Намек понял',
                    items: [
                        'Для начинающих',
                        'Для продвинутых'
                    ]
                },
            ]
        }
    },
    methods: {
        /**
         * Переключить видимость меню
         */
        toggleGameSelect() {
            this.isOpen = !this.isOpen;
        },

        /**
         * Закрыть меню
         */
        closeGameSelect() {
            this.isOpen = false;
        },

        /**
         * Обработчик клика по пункту меню
         * @param e - событие клика
         */
        selectGameType(e) {
            if (e.target.dataset.title) {
                this.currentGameType = e.target.dataset.title;
            }
            this.closeGameSelect();
        }
    }
}
</script>
